import { A, useLocation } from "@solidjs/router";
import { createSignal } from "solid-js";
import { t } from "../i18n";
import { tgHapticImpact } from "../lib/telegram";
import CreateWorkoutSheet from "./CreateWorkoutSheet";

const items = [
  { href: "/", key: "CALENDAR" as const, icon: CalendarIcon },
  { href: "/exercises", key: "EXERCISES" as const, icon: CatalogIcon },
  { href: "/stats", key: "STATS" as const, icon: StatsIcon },
  { href: "/profile", key: "PROFILE" as const, icon: ProfileIcon },
] as const;

export default function BottomNav() {
  const location = useLocation();
  const [sheetOpen, setSheetOpen] = createSignal(false);

  function openCreate() {
    tgHapticImpact("medium");
    setSheetOpen(true);
  }

  const left = () => items.slice(0, 2);
  const right = () => items.slice(2);

  function isActive(href: string) {
    return href === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(href);
  }

  return (
    <>
      <nav class="app-nav" aria-label="Main">
        <div class="nav-bar mx-auto flex max-w-lg items-stretch">
          {left().map((item) => {
            const active = () => isActive(item.href);
            return (
              <A
                href={item.href}
                class={`nav-item flex flex-1 flex-col items-center justify-center gap-0.5 ${
                  active() ? "is-active" : ""
                }`}
              >
                <item.icon active={active()} />
                <span class="nav-item-label">{t(item.key)}</span>
              </A>
            );
          })}

          <button
            type="button"
            class="nav-item nav-item--compose flex flex-1 flex-col items-center justify-center gap-0.5"
            aria-label={t("CREATE_WORKOUT")}
            onClick={openCreate}
          >
            <PlusIcon />
            <span class="nav-item-label">{t("CREATE")}</span>
          </button>

          {right().map((item) => {
            const active = () => isActive(item.href);
            return (
              <A
                href={item.href}
                class={`nav-item flex flex-1 flex-col items-center justify-center gap-0.5 ${
                  active() ? "is-active" : ""
                }`}
              >
                <item.icon active={active()} />
                <span class="nav-item-label">{t(item.key)}</span>
              </A>
            );
          })}
        </div>
      </nav>

      <CreateWorkoutSheet
        open={sheetOpen()}
        onClose={() => setSheetOpen(false)}
      />
    </>
  );
}

function CalendarIcon(_props: { active: boolean }) {
  return (
    <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
}

function CatalogIcon(_props: { active: boolean }) {
  return (
    <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z"
      />
    </svg>
  );
}

function StatsIcon(_props: { active: boolean }) {
  return (
    <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4 19V9m6 10V5m6 14v-7m6 7V8"
      />
    </svg>
  );
}

function ProfileIcon(_props: { active: boolean }) {
  return (
    <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 5v14M5 12h14" />
    </svg>
  );
}
